"use client";

import { c as _c } from "react/compiler-runtime";
import { useWaves } from "@/hooks/useWaves";
import { useEffect } from "react";
import UserPageProfileWavePickerNonReady from "./UserPageProfileWavePickerNonReady";
import UserPageProfileWavePickerReady from "./UserPageProfileWavePickerReady";
import { resolveWavePickerViewState } from "./userPageProfileWave.helpers";
export default function UserPageProfileWavePicker(t0) {
  const $ = _c(28);
  const {
    title,
    identity,
    isOwnProfile,
    hasCreatedProfile,
    hasActiveProfileProxy,
    selectedWaveId,
    submittingWaveId,
    onSelectWave,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "panel" : t1;
  const t2 = isOwnProfile && hasCreatedProfile && !hasActiveProfileProxy && identity.length > 0;
  let t3;
  if ($[0] !== identity || $[1] !== t2) {
    t3 = {
      identity,
      waveName: null,
      limit: 20,
      directMessage: false,
      enabled: t2
    };
    $[0] = identity;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    waves: createdWaves,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    status,
    refetch
  } = useWaves(t3);
  let t4;
  if ($[3] !== createdWaves || $[4] !== hasActiveProfileProxy || $[5] !== hasCreatedProfile || $[6] !== isOwnProfile || $[7] !== status) {
    t4 = resolveWavePickerViewState({
      createdWaves,
      hasCreatedProfile,
      hasActiveProfileProxy,
      isOwnProfile,
      status
    });
    $[3] = createdWaves;
    $[4] = hasActiveProfileProxy;
    $[5] = hasCreatedProfile;
    $[6] = isOwnProfile;
    $[7] = status;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const state = t4;
  let t5;
  if ($[9] !== refetch) {
    t5 = async () => {
      await refetch();
    };
    $[9] = refetch;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const retryWavePickerLoad = t5;
  let t6;
  let t7;
  if ($[11] !== fetchNextPage || $[12] !== hasNextPage || $[13] !== isFetchingNextPage || $[14] !== status) {
    t6 = () => {
      if (status === "success" && hasNextPage && !isFetchingNextPage) {
        const fetchRemainingWaves = async () => {
          await fetchNextPage();
        };
        fetchRemainingWaves().catch(_temp);
      }
    };
    t7 = [fetchNextPage, hasNextPage, isFetchingNextPage, status];
    $[11] = fetchNextPage;
    $[12] = hasNextPage;
    $[13] = isFetchingNextPage;
    $[14] = status;
    $[15] = t6;
    $[16] = t7;
  } else {
    t6 = $[15];
    t7 = $[16];
  }
  useEffect(t6, t7);
  if (state.kind !== "ready") {
    let t8;
    if ($[17] !== retryWavePickerLoad || $[18] !== state || $[19] !== variant) {
      t8 = <UserPageProfileWavePickerNonReady state={state} variant={variant} onRetry={retryWavePickerLoad} />;
      $[17] = retryWavePickerLoad;
      $[18] = state;
      $[19] = variant;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    return t8;
  }
  let t8;
  if ($[21] !== onSelectWave || $[22] !== selectedWaveId || $[23] !== state || $[24] !== submittingWaveId || $[25] !== title || $[26] !== variant) {
    t8 = <UserPageProfileWavePickerReady state={state} title={title} selectedWaveId={selectedWaveId} submittingWaveId={submittingWaveId} onSelectWave={onSelectWave} variant={variant} />;
    $[21] = onSelectWave;
    $[22] = selectedWaveId;
    $[23] = state;
    $[24] = submittingWaveId;
    $[25] = title;
    $[26] = variant;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}
function _temp() {}